import {store} from "@/apps/default/store"
import * as _ from 'lodash'

/**
 * Service to support custom themes.
 * A theme is triggered by a URL pattern (which is typically not an exact domain name, but some subset of
 * the domain name to facilitate matching in various production/dev/demo environments).
 * Each theme can have custom assets such as logo and favicon, as well as custom css and translations (including English).
 * The app can also trigger showing/hiding of various elements or features based on the
 * theme setting in the store state.
 * There is also the CustomThemeService on the backend, which permits customization of backend actions.
 */

const DEFAULT_THEME = {
    name: 'default',
    pageTitle: 'Wellcoaches Healthcare'
}

const CUSTOM_THEMES = [
    {
        name: 'wellcoaches',
        pageTitle: 'Wellcoaches',
        // local dev: ecr.wellcoaches.test
        // dev server: dev-ecr.wellcoaches.app
        urlPattern: 'ecr.wellcoaches',
    },
    {
        name: 'conifer',
        pageTitle: 'Sustainable Health',
        // local dev: conifer.sustainable-health.test
        // dev server: dev-conifer.sustainable-health.app
        urlPattern: 'conifer.sustainable-health',
    },
    {
        name: 'shs',
        pageTitle: 'Sustainable Health',
        // local dev: sustainable-health.test
        // dev server: dev.sustainable-health.app
        urlPattern: 'sustainable-health',
    },
]

/*
* Create an array to relate redirects
* Redirects cannot be done in Route53
* wellcoaches.app -> ecr.wellcoaches.app
* dev.wellcoaches.app -> dev-ecr.wellcoaches.app
* staging.wellcoaches.app -> staging-ecr.wellcoaches.app
* demo.wellcoaches.app -> demo-ecr.wellcoaches.app
*
* Local:
* wellcoaches.test:8009 -> ecr.wellcoaches.test:8009
*
*/

const REDIRECTS = {
    'https://wellcoaches.app/' : 'https://ecr.wellcoaches.app/',
    'https://dev.wellcoaches.app/' : 'https://dev-ecr.wellcoaches.app/',
    'https://staging.wellcoaches.app/' : 'https://staging-ecr.wellcoaches.app/',
    'https://demo.wellcoaches.app/' : 'https://demo-ecr.wellcoaches.app/',

    // for testing redirect locally, default theme can be accessed through localhost:8009
    'http://wellcoaches.test:8009/' : 'http://ecr.wellcoaches.test:8009/',
}
export default {
    // apply a custom theme if one is found matching the current URL
    setCustomTheme() {
        const url = document.location.href
        // check for URL matches
        const theme = _.find(CUSTOM_THEMES, (t) => {
            return url.indexOf(t.urlPattern) !== -1
        })
        const urlIndex = _.find(Object.keys(REDIRECTS), (key) => {
            return url.indexOf(key) !== -1
        })
        const redirectUrl = REDIRECTS[urlIndex]
        if (redirectUrl) {
            document.location.replace(redirectUrl)
        }

        if (theme) {
            store.state.theme = theme
            // apply body class to make custom styles kick in
            document.body.className += ` theme-${theme.name}`
        } else {
            store.state.theme = DEFAULT_THEME
        }
    },

    // each custom theme must have a translations file in public/translations-custom-NAME.csv
    getThemeTranslationFilename() {
        if (store.state.theme && store.state.theme.name != 'default') {
            return `custom-${store.state.theme.name}`
        } else {
            return null
        }
    },

    getDesktopLogoImage() {
        return `/themes/${store.state.theme.name}/logo.png`
    },
    getMobileLogoImage() {
        return `/themes/${store.state.theme.name}/logo-mobile.png`
    },

    // functions that use VueHead to manipulate page headers...
    getVueHeadPageTitle() {
        return {
            inner: store.state.theme.pageTitle, // TODO: support translation here??
            separator: ' ', // NB: must use blank instead of null/empty string to suppress this
            complement: ''
        }
    },
    getVueHeadLinkHeaders() {
        const themeDir = `/themes/${store.state.theme.name}`
        return [
            {rel: 'shortcut icon', href: `${themeDir}/favicon.ico`, type: 'image/png'},
            {rel: 'icon', href: `${themeDir}/favicon-16x16.png`, sizes: '16x16', type: 'image/png'},
            {rel: 'icon', href: `${themeDir}/favicon-32x32.png`, sizes: '32x32', type: 'image/png'},
            {rel: 'mask-icon', href: `${themeDir}/safari-pinned-tab.svg`, color: "#5bbad5"},
            {rel: 'apple-touch-icon', href: `${themeDir}/apple-touch-icon.png`, sizes: "180x180"},
            {rel: 'manifest', href: `${themeDir}/site.webmanifest`},
            // TODO: handle MS browserconfig??
        ]

    }

}
